import { useQuery } from "react-query";
import { getReports } from "../queries/getReports";
import useNetworkHeaders from "./useNetworkHeaders";

export type reportsListResponse = Awaited<ReturnType<ReturnType<typeof getReports>>>;

export function useReportsFetch(queryStringParams: string) {
  const networkHeaders = useNetworkHeaders();
  const reportsListQuery = useQuery(
    ["reports.list", queryStringParams],
    () => getReports(networkHeaders)(queryStringParams),
    {
      refetchOnMount: "always",
    },
  );
  const { data: reportsList, isLoading } = reportsListQuery;

  return { reportsList: reportsList?.data, isLoading };
}
